import React, { forwardRef, useEffect, useRef, useState, type FC } from "react";
import classes from "./Navbar.module.css";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { setAuthModal } from "../Slices/authModalSlice";
import { logoutUser } from "../Slices/userSlice";
import { toast } from "react-toastify";
import { toggleSearchModal } from "../Slices/searchModalSlice";
import { toggleWatchlistModal } from "../Slices/watchlistModalSlice";
import { toggleReviewModal } from "../Slices/reviewModalSlice";
import { toggleUserRatingsModal } from "../Slices/userRatingsModalSlice";
import { toggleProfileModal } from "../Slices/profileModalSlice";
import { toggleDrawer } from "../Slices/drawerSlice";

type navLinkType = {
  id: number;
  item: string;
  link: string;
};

const navLinks: navLinkType[] = [
  {
    id: 1,
    item: "အိမ်",
    link: "/",
  },
  {
    id: 2,
    item: "ရုပ်ရှင်များ",
    link: "/movies",
  },
  {
    id: 3,
    item: "စီးရီး",
    link: "/series",
  },
  {
    id: 4,
    item: "ရပ်ရွာ",
    link: "/community",
  },
  {
    id: 5,
    item: "ဘောင်းဘီတို",
    link: "/shortz",
  },
];

type NavbarProps = {
  activeLink: null | number;
  applyPadding?: boolean;
};

const Navbar = forwardRef<HTMLDivElement, NavbarProps>(
  ({ activeLink, applyPadding }, ref) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const targetRef = useRef<HTMLDivElement>(null);

    const { user } = useAppSelector((state) => state.userSlice);

    const handleNavigate: (link: string) => void = (link) => {
      navigate(link, { state: { reset: true } });
    };
    const [toggle, setToggle] = useState(false);
    const [height, setHeight] = useState(0);

    useEffect(() => {
      console.log(targetRef, "tr");
      if (targetRef.current) {
        console.log(targetRef?.current, "tc");
        console.log(targetRef.current?.offsetHeight, "ofh");
        setHeight(targetRef.current?.offsetHeight);
      }
    }, [targetRef, toggle]);

    const handleSignupClick = () => {
      setToggle(false);
      dispatch(setAuthModal({ authModal: true, authModalType: "signup" }));
    };

    const handleSigninClick = () => {
      setToggle(false);
      dispatch(setAuthModal({ authModal: true, authModalType: "signin" }));
    };

    const signoutHandler = () => {
      setToggle(false);
      dispatch(logoutUser(null));
      toast.success("အောင်မြင်စွာ ထွက်လိုက်ပါ။");
    };

    const handleWatchListClick = () => {
      setToggle(false);
      // navigate("/watchlist");
      dispatch(toggleWatchlistModal());
    };

    const handleRatingsClick = () => {
      setToggle(false);
      dispatch(toggleUserRatingsModal());
    };

    const handleProfileClick = () => {
      setToggle(false);
      dispatch(toggleProfileModal());
    };

    return (
      <div
        className={`${classes.nav} ${applyPadding && classes.padding}`}
        ref={ref}
      >
        <button
          className={classes.logo_container}
          onClick={() => navigate("/")}
        >
          <img
            src="/assets/images/logo2.png"
            alt="logo"
            className={classes.logo}
          />
        </button>

        <div className={classes.nav_links}>
          {navLinks?.map((link, index) => {
            return (
              <button
                className={`${classes.nav_link} ${
                  activeLink === link?.id && classes.active
                }`}
                key={index}
                type="button"
                onClick={() => handleNavigate(link?.link)}
              >
                <p className={classes.link_text}>{link?.item}</p>
              </button>
            );
          })}
          <button
            className={classes.nav_link_search}
            onClick={() => dispatch(toggleSearchModal())}
          >
            <i className={`${classes.icon} pi pi-search`} />
          </button>
          <button
            className={classes.nav_link_search}
            onClick={() => dispatch(toggleDrawer())}
          >
            <i className={`${classes.icon} pi pi-bars`} />
          </button>
        </div>

        <motion.div
          className={classes.profile_container}
          onClick={() => setToggle((prevValue) => !prevValue)}
        >
          <div className={classes.avatar}>
            {toggle ? (
              <i className={`${classes.avatar_icon} pi pi-times`} />
            ) : (
              <i className={`${classes.avatar_icon} pi pi-user`} />
            )}
          </div>

          <motion.div
            data-isOpen={toggle}
            layout
            ref={targetRef}
            className={classes.profile_menu}
            transition={{
              type: "spring",
              stiffness: 700,
              damping: 30,
            }}
            style={{ bottom: `calc(-${height}px - 10px)` }}
            onClick={() => setToggle((prevValue) => !prevValue)}
          >
            {toggle ? (
              <>
                {user ? (
                  <>
                    <button
                      className={classes.signin}
                      onClick={() => handleWatchListClick()}
                    >
                     သင်၏ စောင့်ကြည့်စာရင်း
                    </button>
                    <button
                      className={classes.signin}
                      onClick={() => handleRatingsClick()}
                    >
                    သင့်အဆင့်သတ်မှတ်ချက်များ
                    </button>
                    <button
                      className={classes.signin}
                      onClick={handleProfileClick}
                    >
                      ကိုယ်ရေးအကျဉ်း
                    </button>
                    <button
                      className={classes.signin}
                      onClick={() => navigate("/privacy-policy")}
                    >
                      ကိုယ်ရေးအချက်အလက်မူဝါဒ
                    </button>
                    <button
                      className={classes.signout}
                      onClick={signoutHandler}
                    >
                    ဆိုင်းအောက်
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className={classes.signin}
                      onClick={() => navigate("/privacy-policy")}
                    >
                     ကိုယ်ရေးအချက်အလက်မူဝါဒ
                    </button>
                    <button
                      className={classes.signin}
                      onClick={handleSigninClick}
                    >
                     ဆိုင်းအင်လုပ်ခြင်း
                    </button>

                    <div className={classes.wrapper}>
                      <p className={classes.new_user_text}>အသုံးပြုသူအသစ်လား။</p>
                      <button
                        type="button"
                        className={classes.signup}
                        onClick={handleSignupClick}
                      >
                       အကောင့်ပြုလုပ်ပါ
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : null}
          </motion.div>
        </motion.div>
      </div>
    );
  }
);

export default Navbar;
